import { useEffect, useState } from "react";

/** The typed text once it has held still for a moment. */
export function useSettled(value: string, delayMs: number) {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
}
